import React, { Component } from 'react';
import FieldWrapper from './FieldWrapper';

class Field extends Component {
  render() {
    return (
      <FieldWrapper {...this.props}>
        <input 
          key={this.props.id}
          type={this.props.type}
          id={this.props.id} 
          name={this.props.id} 
          placeholder={this.props.placeholder || this.props.fieldName} 
          className={`form-control input-md ${this.props.errors[this.props.id] && this.props.touched[this.props.id] ? 'inputError' : ''}`}
          value={this.props.values[this.props.id]} 
          onChange={this.props.handleChange}
          onBlur={this.props.handleBlur}

          disabled={this.props.disabled}
          autoComplete={this.props.autoComplete}
        >
        </input>
      </FieldWrapper>
    )
  }
}

export default Field;


// WEBPACK FOOTER //
// ./src/Components/Form/Field.js